export const HOSPITAL_SEARCH_PATTERN_SCORE = {
    NAME_INCLUSIVE_MATCH: 20,
    CITY_INCLUSIVE_MATCH: 10,
    CITY_FUSSY_MATCH: 5,
};
export const HOSPITAL_SEARCH_MAX_RESULT = 50;
export const PINNED_HOSPITAL_LIST = [
    {
        name: '新北市立土城醫院',
        city: '新北市',
    },
    {
        name: '臺大醫院-總院區',
        city: '臺北市',
    },
    {
        name: '林口長庚醫院',
        city: '桃園市',
    },
    {
        name: '亞東醫院',
        city: '新北市',
    },
    {
        name: '臺北榮民總醫院',
        city: '臺北市',
    },
    {
        name: '臺北醫學大學附設醫院',
        city: '臺北市',
    },
    {
        name: '雙和醫院',
        city: '新北市',
    },
    {
        name: '馬偕醫院-臺北總院',
        city: '臺北市',
    },
    {
        name: '國泰醫院-臺北總院',
        city: '臺北市',
    },
    {
        name: '恩主公醫院',
        city: '新北市',
    },
];
export const HOSPITAL_COUNT_PER_PAGE = 30;
